import styled from 'styled-components';

export const CountdownWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  position: relative;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    order: 2;
  }
`;

export const TimeCard = styled.div<{ $width: number; $height: number }>`
  backdrop-filter: blur(10px);
  background-color: ${({ theme }) => theme.colors.offBlack};
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => $width}rem;
  height: ${({ $height }) => $height}rem;
  border-radius: 2rem;
  box-shadow:
    0px 5px 10px 0px rgba(0, 0, 0, 0.05),
    0px 15px 30px 0px rgba(0, 0, 0, 0.05),
    0px 30px 60px 0px rgba(0, 0, 0, 0.1);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 2rem;
    box-shadow: 0px 0px 100px 0px inset rgba(204, 215, 255, 0.15);
    pointer-events: none;
  }
`;

export const TimeValue = styled.p`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: 3.3rem;
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  text-transform: capitalize;
  margin: 0;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    font-size: 2.4rem;
  }
`;

export const TimeLabel = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  margin: 0;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    font-size: 1.4rem;
  }
`;

export const Separator = styled.p`
  font-family: 'Inter';
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: 3.6rem;
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  margin: 0;
`;

export const DecorativeImage = styled.div<{ $width: number; $height: number; $top: number; $right: number }>`
  position: absolute;
  width: ${({ $width }) => $width}rem;
  height: ${({ $height }) => $height}rem;
  top: ${({ $top }) => $top}rem;
  right: ${({ $right }) => $right}rem;
  transform: rotate(23deg);

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
